// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","389":"e7b13feb","453":"8701dc61","455":"22d4e1b1","977":"fad38823"}[chunkId] + ".chunk.js";
};